export default "__VITE_ASSET__w6$X0yoR__"